module.exports = __webpack_public_path__ + "static/copysvg-25cb8bf522b36d8c7cdfee10da8650cc.mp4";